import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { observer } from 'mobx-react';
import css from './TranscriptOnlyFootnote.module.scss';

/**
 * Footnote shown below MomentGrid when a visual/unified search ran
 * against a mixed scope (some transcript-only libraries, some not)
 * and got at least one result. The transcript-only libraries were
 * skipped (see `updateLibrarySearches`); this tells the user which
 * results they're NOT seeing.
 *
 * Gated from SearchPage by `shouldShowTranscriptOnlyFootnote` on the
 * search store — the component doesn't guard internally.
 */
export const TranscriptOnlyFootnote = observer(() => {
  const libraryManager = useLibraryManager();
  const search = libraryManager.multiLibSearch;

  if (!search.shouldShowTranscriptOnlyFootnote) return null;

  return (
    <div className={css.root}>
      <WarningAmberRoundedIcon className={css.icon} />
      <span className={css.text}>
        Some libraries did not produce results because they don&apos;t support Visual Intelligence.
      </span>
    </div>
  );
});
